
import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Merhaba, Ben <span className="text-teal-600">Esin Arifoğlu</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              25+ yıllık fizik öğretmenliği deneyimim ve ICF akreditasyonumla, 
              bilimsel yaklaşımı koçluk metodolojisiyle harmanlayarak size eşlik ediyorum.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Katı Hal Fiziği alanındaki yüksek lisans eğitimim ve Türkiye'nin önde gelen 
              okullarındaki öğretmenlik deneyimim, koçluk süreçlerimde analitik düşünce 
              ve sistematik yaklaşım sağlıyor.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">ICF Akreditasyonu</h4>
                  <p className="text-sm text-gray-600">Uluslararası standartlar</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">25+ Yıl Deneyim</h4>
                  <p className="text-sm text-gray-600">Eğitim ve öğretim</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <i className="ri-microscope-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Bilimsel Yaklaşım</h4>
                  <p className="text-sm text-gray-600">Fizik altyapısı</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-heart-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Empatik Yaklaşım</h4>
                  <p className="text-sm text-gray-600">İnsan odaklı</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/11bca27ccb3d56cff196f9e5dc04b8f8/92c1a1245c6ae3e2e19f7cc1667d41a8.jpeg"
              alt="ICF Koçu Esin Arifoğlu - Profesyonel koçluk hizmetleri"
              className="rounded-2xl shadow-2xl object-cover w-full h-96 lg:h-[500px] object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-user-star-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">500+</p>
                  <p className="text-sm text-gray-600">Öğrenci, Ebeveyn, Kariyer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
